import React, { useEffect } from 'react';
import { useActivation } from '@context/MobileOne';
import {
  ApiError,
  CardMain,
  CardSupport,
  NavigationPageTitle,
  Ta11yText,
  ScrollToTop,
  ButtonCancelActivation
} from '@core/index';
import AppPageContentWrapper from '@part/AppPageContentWrapper';
import { useA11y } from '@context/Utils/A11y'

export function LegitimationMethod() {
  // Contexts
  const { tA11yTranslate } = useA11y();
  const {
    getLegitimationMethods,
    legitimationMethods,
    legitimationError,
    setShowActivationHeader
  } = useActivation();

  useEffect(() => {
    getLegitimationMethods();
    setShowActivationHeader(true); // NEW
  }, []);

  const textContent = tA11yTranslate('ek_reg_choose_legi_txt1');

  return (
    <>
      <ScrollToTop>
        <div className="min-dvh-100">
          <AppPageContentWrapper>
            <div className="pb-16">
              <NavigationPageTitle isBackButton={false} headingTag='h2' title="ek_reg_choose_legi_hdl1" variant="sm" />
            </div>
            <Ta11yText textContent={textContent} className="ek-copy-16-regular pb-40" tag="p" />
            {legitimationMethods?.length ? (
              <div className="legitimation-method-container pb-8">
                {legitimationMethods.map((legitimation) => (
                  <div className="mb-40" key={legitimation.id}>
                    <CardMain
                      cardId={legitimation.id}
                      isRecomended={legitimation.isRecomended}
                      chip="ek_global_recommended_chip"
                      headline={tA11yTranslate(legitimation.headline)}
                      imageSource={legitimation.imageSource}
                      description={tA11yTranslate(legitimation.description)}
                      buttonProps={legitimation.buttonProps}
                      description2={tA11yTranslate(legitimation.description2)}
                      secondaryButtonProps={legitimation.secondaryButtonProps}
                    />
                  </div>
                ))}
              </div>
            ) : null}
            {legitimationError && (
              <div className="pb-40">
                <ApiError message={legitimationError} />
              </div>
            )}
            <CardSupport />
            <div className="d-flex justify-content-center mt-32">
              <ButtonCancelActivation />
            </div>
          </AppPageContentWrapper>
        </div>
      </ScrollToTop>
    </>
  );
}

export default LegitimationMethod;
